module.exports = __webpack_public_path__ + "static/media/open-doodles-selfie.5883bce3.svg";